/*
 * CarrierClaimPill — shared pill rendered next to late_delivery /
 * no_movement claims. When the backend enriches the claim with a real
 * file_url (XCover for insured packages, carrier portal for direct), the
 * pill becomes a 1-click link. Otherwise renders as a static chip.
 */
import { ExternalLink, ShieldCheck, Truck } from "lucide-react";

export default function CarrierClaimPill({ cc }) {
  if (!cc) return null;
  const insured = cc.insurance?.insured;
  const tone = insured
    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : "bg-indigo-50 text-indigo-700 border-indigo-200";
  const label = insured ? "XCover claim" : "Carrier claim";
  const amountPart = cc.insurance?.amount
    ? ` · $${Number(cc.insurance.amount).toFixed(0)} insured`
    : "";
  const title = [
    cc.claim_id,
    cc.liability ? `${cc.liability} liable` : null,
    cc.status,
    amountPart.trim(),
  ].filter(Boolean).join(" · ");
  const Icon = insured ? ShieldCheck : Truck;
  const baseCls = `ml-1.5 text-[10px] mono uppercase tracking-[0.14em] px-1.5 py-0.5 rounded-full border inline-flex items-center gap-1 ${tone}`;
  if (cc.file_url) {
    return (
      <a href={cc.file_url} target="_blank" rel="noreferrer"
         onClick={e => e.stopPropagation()}
         data-testid={`carrier-claim-${cc.claim_id}`}
         className={baseCls + " hover:opacity-80 transition"}
         title={title}>
        <Icon className="w-2.5 h-2.5"/>{label}<ExternalLink className="w-2.5 h-2.5"/>
      </a>
    );
  }
  return (
    <span data-testid={`carrier-claim-${cc.claim_id}`}
          className={baseCls} title={title}>
      <Icon className="w-2.5 h-2.5"/>{label}
    </span>
  );
}
